import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import { AttendeesLiveFormPresentation } from './attendees-live-presentation';
import AttendeesLiveFormVM from './attendees-live-form.viewmodel';
import {IAttendeeOrganizationDTO} from '../../../../../api/attendees.dao';
import { AttendeeColumnPopoverViewmodel } from '../../../../global/attendee-column/attendee-column-popover/attendee-column-popover.viewmodel';

export interface IAttendeesLiveFormContainerProps {
    accountId: number;
    eventId: number;
    meetingId: number;
    presenters: IAttendeeOrganizationDTO[];
    startDateTime: Date;
    endDateTime: Date;
    total?: number;
    registrantsCount: number;
    eventTimezone: string;
    isTypesForMeetingsWithCounters: boolean;
    attendeeDetailsPopoverVM?: AttendeeColumnPopoverViewmodel;
}

const AttendeesLiveFormContainer = withViewModel(AttendeesLiveFormPresentation, (props: IAttendeesLiveFormContainerProps) => {
    const attendeesLiveFormVM = new AttendeesLiveFormVM();
    attendeesLiveFormVM.initialize(props);
    return attendeesLiveFormVM;
});

export { AttendeesLiveFormContainer as AttendeesLiveForm };
